import {Component} from '@angular/core';

import {SharedModule} from '../../../../../shared/shared.module';
import {DialogMsgSupplier, Paragraphe} from '../../../../../core/suppliers/dialog-msg-supplier';
import {HELP_FOLDERS} from '../../../../../core/constants';

@Component({
  selector: 'yo-declinaison-help',
  templateUrl: './declinaison-help.component.html',
  standalone: true,
  imports: [
    SharedModule
  ]
})
export class DeclinaisonHelpComponent {

  pathFile: string = HELP_FOLDERS.PRODUITS + '/edition-produits-declinaisons';

  dialogMsgSupplier = (): DialogMsgSupplier => {
    let dms = new DialogMsgSupplier();
    dms.title = `Paramétrage d'un produit/denrée`;
    dms.logo = 'fa fa-question-circle  yoni-color';

    let p1: Paragraphe = new Paragraphe();
    p1.title = `Déclinaison d'un <b>produit/denrée</b>`;
    p1.lines = [
      `On retrouve ici des paramètres qui seront réutilisés en création de <b>plat</b> :`,
      `<ul>
        <li>unité technique</li>
        <li>ration entre unité technique et l'unité universelle le Kg</li>
      </ul>`,
    ];

    dms.content = {
      intro: `Une <b>déclinaison</b> comporte les paramètres orientés « production ».`,
      paragraphes: [p1]
    };

    return dms;
  };
}
